import React from "react";

function Polutions() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="44"
      fill="none"
      viewBox="0 0 44 44"
    >
      <g
        stroke="#13121A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.75"
        clipPath="url(#clip0_226_645)"
      >
        <path d="M12.833 33c-2.287 0-4.481-.87-6.099-2.416-1.617-1.547-2.526-3.646-2.526-5.834 0-2.188.909-4.286 2.526-5.834 1.618-1.547 3.812-2.416 6.099-2.416.54-2.407 2.12-4.522 4.394-5.88a10.947 10.947 0 013.713-1.372 11.41 11.41 0 014.013.01c1.325.241 2.583.714 3.704 1.393a9.83 9.83 0 012.83 2.562 8.771 8.771 0 011.525 3.341A8.351 8.351 0 0133 20.167h1.833a6.417 6.417 0 110 12.833M20.167 27.5v.018m0 5.5v.019m0 5.5v.018m7.333-7.333v.018m0 5.5v.018"></path>
      </g>
      <defs>
        <clipPath id="clip0_226_645">
          <path fill="#fff" d="M0 0H44V44H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Polutions;
